import { ref, type Ref } from "vue";

export const alertMessageEmptyHappy = {
    title: '',
    message: "",
    class: "",
    errors: []
}

export interface IAlertMessageHappy {
    title: string;
    message: string;
    class: string;
    errors: string[];
}

export const alertMessageHappy: Ref<IAlertMessageHappy> = ref(alertMessageEmptyHappy)
export const showAlertMessageHappy: Ref<boolean> = ref(false);